import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findGoodsQr= (id,params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/list/${id}?`+params,
        method: 'GET'
    })
}
export const findParentAll= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/parents?`+params,
        method: 'GET'
    })
}
export const addGoodsQr = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/insertQr`,
        method: 'POST',
        data: data
    })
}
export const findBrand = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/brand`,
        method: 'GET'
    })
}
export const findClassify = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose`,
        method: 'GET'
    })
}
export const deleteQr = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/parents/${id}`,
        method: 'DELETE'
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/binding/selectShops`,
        method: 'GET'
    })
}
export const findBindingList = (params) => {
    params = parseParam(params);
    return request({
      url: `${baseUrl}/joins-sales-cloud/v1/binding/list?` + params,
      method: "GET",
    });
  };
export const chooseSecondClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
        method: 'GET'
    })

}
export const findGoodsByRootDepartId = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods?`+params,
        method: 'GET'
    })
}
export const findPureWaterGoodsByRootDepartId = (type) => {
    if(type){
        return request({
            url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/findPureWaterGoodsByRootDepartId?type=${type}`,
            method: 'GET'
        })
    }else{
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/findPureWaterGoodsByRootDepartId`,
        method: 'GET'
    })
}
}
export const findPureWaterGoodsByRootDepartIds = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/findPureWaterGoodsByRootDepartIdNotEngineering`,
        method: 'GET'
    })
}
// 用engineeringGoodsId查询工程商品
export const findEngineeringGoods = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/engineering_goods/${id}`,
        method: 'GET'
    })
}
export const batchDownloadQrCode = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/qr/batchDownloadQrCode/${temp}`,
        method: 'get'
    })
}
export const batchDownloadQr = (ids) => {
    let temp = ids.join(",")
    let url=`${baseUrl}`+`/joins-sales-cloud/v1/qr/downloadGoodsQrCode/${temp}`
    window.open(url);
}
export const batchDownloadQr2 = (ids) => {
    let temp = ids.join(",")
    let url=`${baseUrl}`+`/joins-sales-cloud/v1/qr/downloadZip/${temp}`
    window.open(url);
}
export const downloadQr = (id) => {
    return request({
      url: `${baseUrl}/joins-sales-cloud/v1/qr/downloadDoc/${id}`,
      method: "GET",
      responseType: 'blob',
      /* params: {
        id: id,
      }, */
    });
  };
// 账户余额
export const findAccountBalance = () => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_detail/balance`,
        method: 'GET'
    })
}
// 积分余额
export const findIntegralBalance = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-integral/v1/detail/balance?` + params,
        method: 'GET'
    })
}
//支付
export const pay = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/preFilter/preFilterPay/${id}`,
        method: 'GET'
    })
}